import { Grid, Box, Typography } from '@mui/material';

import useLanguage from 'src/hooks/Language/useLanguage';
import { TRefundRateReportData, TRefundRateReportItem } from 'src/types/Reports/refundRate.model';
import RefundRateColumnChart from './RefundRateStackedChart';

type RefundRateProps = {
  data: TRefundRateReportData;
};

const RefundRateReportContainer = ({ data }: RefundRateProps) => {
  const { language } = useLanguage();
  const currentData = { ...data };
  currentData.refundRateReportDatas?.map((item: TRefundRateReportItem, index) => {
    item.index = index + 1;
    return item;
  });

  if (!currentData) {
    return <></>;
  }

  return (
    <Grid spacing={0} container className="pt-16">
      <Box className="p-0 pr-8 w-full" flex={1}>
        <Grid container spacing={0}>
          <Typography variant="h4" className="w-full px-8">
            {language.salesReportsPage.teamName}: {currentData.teamName}
          </Typography>

          <Grid container spacing={0} className="p-8">
            {currentData.refundRateReportDatas &&
              currentData.refundRateReportDatas.map((item: TRefundRateReportItem) => (
                <Grid xs={12} md={12} sm={4} key={item.index} item>
                  <div className="flex justify-items-start items-center">
                    <strong className="w-16">{item.index}</strong>
                    <span className="p-0">{item.name}</span>
                  </div>
                </Grid>
              ))}
          </Grid>

          <Grid xs={12} sm={12} item>
            <Box className="w-full h-screen">
              <RefundRateColumnChart data={currentData} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default RefundRateReportContainer;
